import { createFileRoute } from "@tanstack/react-router";

import { VisitLinkPage } from "@/features/public/visit-link";

/**
 * The visit link: the no-login page a vendor's technician opens from the
 * visit monitor's text (`https://bw.app/v/<code>` redirects here).
 *
 * Deliberately OUTSIDE the `(member)` route group: the reader is a vendor's
 * technician, not a member, so the page must not inherit the group's
 * IntercomProvider (no member support chat bubble) or its GTM analytics. Nor
 * is it under the office layout: a technician has no Statsig user, and the
 * page is never behind a feature gate. It still sits under the root providers
 * (query client, platform client).
 *
 * `noindex`: holding the link code is the only gate to the page, so no search
 * engine may list it.
 */
export const Route = createFileRoute("/v/$linkCode")({
  component: VisitLinkPage,
  head: () => ({
    meta: [
      { title: "Birdwatch - Visit details" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
